export const BUTTON_HEIGHT = 44;
export const RECENT_SCOPES_LIMIT = 5;
